import { render, staticRenderFns } from "./HeadingBlock.vue?vue&type=template&id=83d4c8e2&scoped=true&lang=pug&"
import script from "./HeadingBlock.vue?vue&type=script&lang=js&"
export * from "./HeadingBlock.vue?vue&type=script&lang=js&"
import style0 from "./HeadingBlock.vue?vue&type=style&index=0&id=83d4c8e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83d4c8e2",
  null
  
)

/* custom blocks */
import block0 from "./HeadingBlock.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports